const catalogData = [
  {
    category: "Healthcare & Diagnostic Equipment",
    description:
      "Advanced diagnostic and monitoring equipment used in hospitals, clinics, and laboratories to ensure accurate patient assessment and effective treatment."
  },
  {
    category: "Orthopedic & Support Care",
    description:
      "High-quality orthopedic and rehabilitation products designed to support mobility, recovery, and injury management."
  },
  {
    category: "Hygiene & Cotton Products",
    description:
      "Sterile and non-sterile hygiene consumables essential for maintaining cleanliness and infection control in healthcare environments."
  },
  {
    category: "Medical Dressings & Accessories",
    description:
      "Comprehensive range of wound care and dressing solutions for safe and effective patient recovery."
  },
  {
    category: "Apparel & Protective Wear",
    description:
      "Protective medical clothing and safety gear designed to ensure hygiene and safety for healthcare professionals."
  },
  {
    category: "Weighing Scales & Measurement Devices",
    description:
      "Precision weighing and measurement solutions for accurate patient monitoring and diagnostics."
  },
  {
    category: "Surgical Instruments & Examination Tools",
    description:
      "Professional-grade surgical instruments and diagnostic tools for precision and reliability in medical procedures."
  },
  {
    category: "Hospital Furniture & Infrastructure",
    description:
      "Durable and ergonomic hospital furniture solutions designed for patient comfort and efficient healthcare operations."
  }
];
export default catalogData;